import React from "react";
import "./styles/Footer.css";
import Wave from "../components/Wave";
import logo from "../assets/newro-beige-logo.svg";
import { useNavigate } from "react-router";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";

const Footer = ({ pageOn, handleScroll }) => {
  const navigate = useNavigate();

  function navButtonClicked(type) {
    switch (pageOn) {
      case "landing":
        if (type === "about") {
          navigate("/about");
        } else {
          handleScroll(type);
        }
        break;
      case "about":
        if (type === "about") {
          navigate("/about");
        } else {
          navigate("/#" + type);
          // handleScroll(type)
        }
        break;
      case "event":
        if (type === "about") {
          navigate("/about");
        } else {
          navigate("/#" + type);
          // handleScroll(type)
        }
        break;
      default:
        break;
    }
  }

  return (
    <div className="footer-section">
      <Wave position={"top"} />
      <div className="content">
        <div className="menu">
          <div className="company">
            <div className="logo">
              <img src={logo} className="logo-image" alt="logo" />
              <h1>newro</h1>
            </div>
            <p>©2025 newro</p>
          </div>
          <div className="details">
            <div className="contact">
              <h2>Located</h2>
              <p>Durbanville</p>
              <p>Western Cape</p>
              <p>South Africa</p>
            </div>
            <div className="navigation">
              <h2>Navigation</h2>
              <p onClick={() => navButtonClicked("home")}>Home</p>
              <p onClick={() => navButtonClicked("about")}>About</p>
              <p onClick={() => navButtonClicked("faq")}>FAQ</p>
              <p onClick={() => navButtonClicked("contact")}>Contact</p>
            </div>

            <div className="legal">
              <h2>Legal</h2>
              <a href="/privacy-policy" target="_blank">
                <p>Privacy Policy</p>
              </a>
              <a href="/cookie-policy" target="_blank">
                <p>Cookie Policy</p>
              </a>
              <a href="/terms-of-use" target="_blank">
                <p>Terms of Service</p>
              </a>
            </div>
            <div className="social">
              <h2>Social Media</h2>
              <div className="icons">
                <a href="https://www.facebook.com/profile.php?id=61575885699442">
                  <FacebookIcon />
                </a>
                <a href="https://www.instagram.com/hellonewro/">
                  <InstagramIcon />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
